import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AccessDeniedPage from '../pages/AccessDeniedPage';

interface PermissionRouteProps {
  claim: string;
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ claim }) => {
  const { hasPermission } = useAuth();
  return hasPermission(claim) ? <Outlet /> : <AccessDeniedPage />;
};

export default PermissionRoute;
